import { render } from "./Home2.vue?vue&type=template&id=12061796&scoped=true"
import script from "./Home2.vue?vue&type=script&lang=js"
export * from "./Home2.vue?vue&type=script&lang=js"

import "./Home2.vue?vue&type=style&index=0&id=12061796&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12061796"]])

export default __exports__